module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/270.600367f6.png";